import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Action, ActionCreator } from '@ngrx/store';
import { Creator } from '@ngrx/store/src/models';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

export function mwCreateApiEffect<
  E extends Extract<U, { type: T }>,
  AC extends ActionCreator<string, Creator>,
  TApiResult,
  T extends string | AC,
  U extends Action = Action,
  V = T extends string ? E : ReturnType<Extract<T, AC>>
>(
  actions$: Actions,
  action: T,
  apiServiceCall: (actionParams: V) => Observable<TApiResult>,
  resultCallback: (result: TApiResult, actionParams: V) => Action,
  errorCallback?: (err: any, actionParams: V) => Action
): Observable<Action> {
  const apiServiceCall$ = (actionParams: V): Observable<Action> => {
    let stream$ = apiServiceCall(actionParams).pipe(
      map((result: TApiResult) => resultCallback(result, actionParams))
    );

    if (errorCallback) {
      stream$ = stream$.pipe(
        catchError((err) => of(errorCallback(err, actionParams)))
      );
    }

    return stream$;
  };

  const actionsSourceResult = actions$.pipe(
    ofType<E, AC, T, U, V>(action),
    switchMap((actionParams) => apiServiceCall$(actionParams))
  );

  return createEffect(() => actionsSourceResult);
}
